// Types
import { RevenueOrderOrderItem } from 'types'

// Utils
import { priceString } from 'components/base/price'

import styles from './summarylist.css'

type SummaryListProps = {
  items: Array<RevenueOrderOrderItem>
  currency: string
}

const SummaryList = ({ items, currency }: SummaryListProps): JSX.Element => {
  return (
    <div className={styles.summaryList}>
      <ul>
        {items
          .sort((a, b) => new Date(b.reporting_open).getTime() - new Date(a.reporting_open).getTime())
          .map(({ songs, period }) => {
            return (
              <li key={period} className={styles.period}>
                <h4>{period}</h4>
                <ul>
                  {Object.values(songs).map(({ title, streams }) => {
                    const totalAmount = streams.reduce((acc, s) => acc + (s.royalty_amount_converted - s.recouped_amount_converted), 0)
                    return (
                      <li key={title}>
                        <ul>
                          <li className={styles.sourceWrapper}>
                            <span className={styles.songTitle}>{title}</span>
                            <span>{priceString(totalAmount, currency)}</span>
                          </li>
                        </ul>
                      </li>
                    )
                  })}
                </ul>
              </li>
            )
          })}
      </ul>
    </div>
  )
}

export default SummaryList
